import styled from "styled-components";

export const AddMemberForm = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  margin-top: 16px;

  > :first-child {
    flex: 1;
    min-width: 220px;
    max-width: 400px;
  }
`;

export const AddMemberToggle = styled.button`
  margin-top: 16px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: var(--brand);

  &:hover {
    text-decoration: underline;
  }
`;

export const AddMemberHint = styled.p`
  margin: 12px 0 0;
  font-size: 13px;
  color: #64748b;
`;

export const MemberActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MemberStatusToggle = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const ConfirmText = styled.div`
  max-width: 450px;

  p {
    margin: 0 0 8px 0;
    font-size: 14px;
    line-height: 1.5;

    strong {
      font-weight: 600;
    }
  }
`;

export const AppAccessList = styled.div`
  min-width: 320px;
  max-width: 450px;
`;

export const AppAccessRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 0;
  font-size: 14px;
  font-weight: 600;

  & + & {
    border-top: 1px solid #e2e8f0;
  }
`;
